<template>
  <div class="main-container">

    <div class="container">

    
    </div>

  </div>
</template>

<script>
    import {elements_classes} from '../mixins/elements_classes'

    export default {
        name: "animation",
        mixins: [elements_classes],
        data(){
            return{
                // this_page: 'animation'
            }
        },
        computed: {
            this_page(){
                return this.$route.name
            }

        },
        methods: {
            init_animation: function(){
                var head = document.getElementsByTagName('head')[0];
                var script = document.createElement('script');
                script.onload = function(){init()};
                script.type = 'text/javascript';
                script.id = "animation_src";

                script.src = this.$store.getters.page_address + 'assets/game/animation/animation-demo/animation-center.js';

                head.appendChild(script);

                animation_redirect = this.animation_redirect
            },
            animation_redirect(){
                this.$router.push({name: this.$store.state.allowed_stages[this.$store.state.allowed_stages.length - 2]})
            }
        },
        created(){

            var head = document.getElementsByTagName('head')[0];

            var script2 = document.createElement('script');
            script2.type = 'text/javascript';
            script2.id = "animation_src2222";
            script2.src = this.$store.getters.page_address + 'assets/game/animation/createjs-2015.11.26.min.js'
            script2.onload = ()=>{
                this.init_animation()
            };
            head.appendChild(script2);
        },
        mounted(){

        }
    }

</script>

<style scoped>
</style>